import { Task } from "@/api/mutation/useTaskCreateMutation";
import useAllTaskQuery from "@/api/query/useAllTaskQuery";
import PercentageCircle from "@/components/shared/PercentageCircle";
import Table, { ColumeDef } from "@/components/shared/Table";
import TaskSubTaskForm from "@/components/tasks/taskSubTaskForm";
import { Button } from "@/components/ui/button";
import dateFormater from "@/helperFuntions/dateFormater";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Dialog from "@/components/common/Dialog";
import useRemoveTaskMutation from "@/api/mutation/useTaskRemove";
import TrashCan from "../../assets/svg/TrashCan.svg";
import Edit from "../../assets/svg/NewEditIcon.svg";
import { toast } from "react-toastify";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import NewEditIcon from "@/assets/svg/NewEditIcon.svg";
import UserAvatar from "@/components/ui/userAvatar";
import {
  StatusEnumSchema,
  ProjectStatusEnumValue,
  TaskStatusEnumValue,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import { useUser } from "@/hooks/useUser";
import RedFlag from "@/assets/svg/RedFlag.svg";
import OrangeFlag from "@/assets/svg/OrangeFlag.svg";
import GreenFlag from "@/assets/svg/GreenFlag.svg";
import { errorConfig } from "@/lib/toastError";
import {
  TooltipProvider,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import useTaskDuplicateMutation from "@/api/mutation/useDuplicateTaskMutation";
import DuplicateIcon from "@/assets/svg/DuplicateIcon.svg";
import SubtaskArrow from "@/assets/svg/SubtaskArrow.svg";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import useProjectDetail from "@/api/query/useProjectDetailQuery";
import type { AssignedUsers } from "@/api/query/useProjectQuery";
import Extermination from "@/assets/v2/svg/Extermination.svg";
import BlueAttachment from "@/assets/v2/svg/BlueAttachment.svg";
import Note from "@/assets/v2/svg/Note.svg";
import useProjectWithoutCalulationQuery from "@/api/query/useProjectWithoutCalulationQuery";
import {
  canManageProjectTasksAndContent,
  normalizeProjectScope,
} from "@/utils/projectRoleAccess";
import ProjectStatusEditBlockedDialog from "@/components/project/ProjectStatusEditBlockedDialog";

function Tasks(props: {
  data: Task[];
  expandChild: boolean;
  selectedTask: (data: string[]) => void;
  /** From TaskViews: avoids a second concurrent GET /project/:id */
  projectStatus?: string;
  projectAssignedUsers?: AssignedUsers[];
}) {
  const [taskData, setTaskData] = useState<Task[]>();
  const [filterData, setFilterData] = useState<Task[] | undefined>(taskData);
  const [taskId, setTaskId] = useState<string | undefined>();
  const [taskCreate, setTaskCreate] = useState<boolean>(false);
  const { projectId } = useParams();
  const allTaskQuery = useAllTaskQuery(projectId, false);
  const [showConfirmDelete, setShowConfirmDelete] = useState<string | null>(
    null
  );
  const user = useUser();
  const { t } = useTranslation();
  const [selectedTasks, setSelectedTasks] = useState<string[]>([]);
  const taskDuplicate = useTaskDuplicateMutation();

  const needsProjectDetailQuery =
    props.projectStatus === undefined ||
    props.projectAssignedUsers === undefined;

  const projectDetailQuery = useProjectDetail(
    projectId,
    needsProjectDetailQuery,
  );

  const projectStatus =
    props.projectStatus ?? projectDetailQuery.data?.data.data.status;

  const projectAssignedUsers =
    props.projectAssignedUsers ??
    projectDetailQuery.data?.data.data.assignedUsers;
  const isProjectEditBlocked =
    projectStatus === ProjectStatusEnumValue.CANCELLED ||
    projectStatus === ProjectStatusEnumValue.ON_HOLD ||
    projectStatus === ProjectStatusEnumValue.COMPLETED ||
    projectStatus === ProjectStatusEnumValue.CLOSED;

  const [isProjectEditBlockedDialogOpen, setIsProjectEditBlockedDialogOpen] =
    useState(false);

  const openProjectSettingsLink = `/project-details/${projectId}`;

  const showProjectEditBlockedDialog = () => {
    setIsProjectEditBlockedDialogOpen(true);
  };

  const tryOpenTaskModal = (nextTaskId?: string) => {
    setTaskId(nextTaskId);
  };

  const tryDuplicateTask = (nextTaskId: string) => {
    if (isProjectEditBlocked) {
      showProjectEditBlockedDialog();
      return;
    }
    taskDuplicate.mutate(nextTaskId, {
      onSuccess: (data) => {
        allTaskQuery.refetch();
        toast.success(data.data.message);
      },
      onError: (err) => {
        allTaskQuery.refetch();
        toast.error(
          errorKeyFormate(err.response?.data.message + ""),
          errorConfig
        );
      },
    });
  };
  // const verification = () => {
  //   if (user.user?.userOrganisation[0].role === UserRoleEnumValue.ADMINISTRATOR) {
  //     return true;
  //   } else {
  //     const projectMenager =
  //       projectDetailQuery.data?.data.data.assignedUsers.find((item) => {
  //         if (
  //           item.projectRole === UserRoleEnumValue.PROJECT_MANAGER &&
  //           user.user?.userId === item.user.userId
  //         ) {
  //           console.log(item);
  //           return item;
  //         }
  //       });

  //     if (projectMenager) {
  //       return true;
  //     }
  //   }
  //   return false;
  // };
  const close = () => {
    allTaskQuery.refetch();
    setTaskId(undefined);
    setTaskCreate(false);
  };
  useEffect(() => { }, [selectedTasks]);

  const onSelectTask = (taskId: string) => {
    const accumulateSubTaskIds = (
      taskId: string,
      taskArray: any[]
    ): string[] => {
      const subTaskIds: string[] = [taskId];
      const selectedTask = taskArray.find((ft) => ft.taskId == taskId);
      if (selectedTask) {
        selectedTask.subtasks.forEach((st: Task) => {
          subTaskIds.push(st.taskId);
          if (st.subtasks.length > 0) {
            subTaskIds.push(...accumulateSubTaskIds(st.taskId, taskArray));
          }
        });
      }

      return subTaskIds;
    };

    const subTaskIds = accumulateSubTaskIds(
      taskId,
      allTaskQuery.data?.data.data ?? []
    );

    if (!selectedTasks.includes(taskId)) {
      setSelectedTasks([...new Set([...(selectedTasks ?? []), ...subTaskIds])]);
    } else {
      const removeTaskIds = selectedTasks.filter(
        (t) => !subTaskIds.includes(t)
      );
      setSelectedTasks(removeTaskIds);
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    props.selectedTask(selectedTasks);
  }, [selectedTasks]);
  const projects = useProjectWithoutCalulationQuery(false);
  useEffect(() => {
    if (!projects.isFetched) {
      projects.refetch();
    }
  }, [projects.isFetched]);
  const isCollaborator = () => {
    const project = projects.data?.data.data.find(
      (p) => p.projectId == projectId
    );
    if (
      project?.assignedUsers.find(
        (u) =>
          u.user.userId == user.user?.userId &&
          u.projectRole == UserRoleEnumValue.COLLABORATOR
      )
    ) {
      return false;
    } else {
      return true;
    }
  };
  const curruntUserProjectRole = projectAssignedUsers?.find(
    (item) => item.user.userId == user?.user?.userId,
  )?.projectRole;

  const listProject = projects.data?.data.data.find(
    (p) => p.projectId == projectId,
  );
  const canManageTasks = useMemo(() => {
    if (!user.user || !listProject) return false;
    return canManageProjectTasksAndContent(
      user.user,
      user.user.userOrganisation[0]?.role,
      listProject.assignedUsers,
      normalizeProjectScope(listProject),
    );
  }, [user.user, listProject]);

  const columnDef: ColumeDef[] = [
    {
      key: "taskId",
      header: "taskId",
      width: 50,
      onHeaderRender: () => {
        if (
          canManageTasks ||
          curruntUserProjectRole !== UserRoleEnumValue.TEAM_MEMBER
        ) {
          return (
            <input
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) {
                  filterData?.forEach(() => {
                    setSelectedTasks(
                      allTaskQuery.data?.data.data?.map((r) => r.taskId) ?? []
                    );
                  });
                } else {
                  setSelectedTasks([]);
                }
              }}
              checked={
                selectedTasks?.length == allTaskQuery.data?.data.data?.length
              }
            />
          );
        } else {
          return <></>;
        }
      },
      onCellRender: (data: Task) => {
        return (
          <div className="w-fit">
            <input
              key={data.taskId}
              type="checkbox"
              onChange={() => {
                onSelectTask(data.taskId);
              }}
              disabled={!allowed(data)}
              checked={selectedTasks.includes(data.taskId)}
            />
          </div>
        );
      },
    },
    {
      key: "flag",
      header: t("flag"),
      sorting: true,
      width: 90,
      onCellRender: (item: Task) => {
        const activeRisks =
          item?.taskRisks?.filter(
            (tr) => tr.risk?.status !== StatusEnumSchema.CLOSE,
          ) ?? [];
        return <div className={`cursor-pointer w-fit flex items-center gap-1`}>
          {item.parentTaskId && (
            <img src={SubtaskArrow} className={"h-5 w-5 min-w-5"} />
          )}
          <div className="w-12 flex items-center gap-1 " >
            {activeRisks.length > 0 && (
              <TooltipProvider delayDuration={0} skipDelayDuration={0}>
                <Tooltip delayDuration={0}>
                  <TooltipTrigger asChild>
                    <img src={Extermination} className="h-3 w-3 min-w-3" />
                  </TooltipTrigger>
                  <TooltipContent
                    side="top"
                    sideOffset={12}
                    align="start"
                    className="max-w-[240px]"
                  >
                    <div className="flex flex-col max-w-60 w-60 font-semibold gap-0.5 text-sm">
                      {t("AssociatedRisk")}
                      <div className="w-52 mt-2 text-xs truncate font-normal">
                        {activeRisks
                          ?.slice()
                          .reverse()
                          .slice(0, 3)
                          .map((att) => {
                            return (
                              <div
                                key={att.taskRiskId}
                                className="truncate cursor-pointer w-52 mt-1"
                                onClick={() => {
                                  if (att.riskId && projectId) {
                                    navigate(`/risk/${projectId}`, {
                                      state: att.risk,
                                    });
                                    window.history.replaceState({}, "");
                                  }
                                }}
                              >
                                {att.risk?.riskNameId} : {att.risk?.title}
                              </div>
                            );
                          })}
                        <div
                          className="w-52 flex justify-end mt-4 mb-2 mr-3 text-secondary underline cursor-pointer"
                          onClick={() => {
                            navigate(`/risk/${projectId}?impactedTasks=${item?.taskId}`);
                          }}
                        >
                          {t("show more")}
                        </div>
                      </div>
                    </div>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
            {item?.documentAttachments &&
              item?.documentAttachments?.length > 0 && (
                <TooltipProvider delayDuration={0}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <button
                        type="button"
                        className="p-0 border-0 bg-transparent cursor-pointer inline-flex items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          tryOpenTaskModal(item.taskId);
                        }}
                      >
                        <img
                          src={BlueAttachment}
                          className="h-3 min-w-3"
                          alt={t("Attachments")}
                        />
                      </button>
                    </TooltipTrigger>
                    <TooltipContent
                      side="top"
                      sideOffset={12}
                      align="start"
                      className="max-w-[240px]"
                    >
                      <div className="flex flex-col max-w-60 w-60 font-semibold gap-0.5 text-sm">
                        {t("attachment")}
                        <div className="w-52 mt-2 text-xs truncate font-normal">
                          {item.documentAttachments
                            ?.slice()
                            .reverse()
                            .slice(0, 3)
                            .map((att) => {
                              const displayName =
                                att.label && att.label.trim() !== ""
                                  ? att.label
                                  : att.name;
                              return (
                                <div
                                  key={att.attachmentId}
                                  className="truncate mt-1 w-52"
                                >
                                  {displayName}
                                </div>
                              );
                            })}
                          <div
                            className="w-52 flex justify-end mt-4 mb-2 mr-3 text-secondary underline cursor-pointer"
                            onClick={() => {
                              tryOpenTaskModal(item.taskId);
                            }}
                          >
                            {t("show more")}
                          </div>
                        </div>
                      </div>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
            {item?.taskNotes && item?.taskNotes?.length > 0 && (
              <TooltipProvider delayDuration={0}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <button
                      type="button"
                      className="p-0 border-0 bg-transparent cursor-pointer inline-flex items-center"
                      onClick={(e) => {
                        e.stopPropagation();
                        tryOpenTaskModal(item.taskId);
                      }}
                    >
                      <img
                        src={Note}
                        className="h-3 w-3 min-w-3"
                        alt={t("Attachments")}
                      />
                    </button>
                  </TooltipTrigger>
                  <TooltipContent
                    side="top"
                    sideOffset={12}
                    align="start"
                    className="max-w-[240px]"
                  >
                    <div className="flex flex-col max-w-60 w-60 font-semibold gap-0.5 text-sm">
                      {t("notes")}
                      <div className="w-52 mt-2 text-xs font-normal">
                        <ol className="!list-disc ">
                          {item?.taskNotes
                            ?.slice() // create copy so original array is not mutated
                            .reverse() // newest first
                            .slice(0, 3) // take only 3 notes
                            .map((note) => {
                              return (
                                <li
                                  key={note.noteId}
                                  className="w-52 truncate mt-1"
                                >
                                  {note.note}
                                </li>
                              );
                            })}
                        </ol>
                        <div
                          className="w-52 flex justify-end mt-4 mb-2 mr-3 text-secondary underline cursor-pointer"
                          onClick={() => {
                            tryOpenTaskModal(item.taskId);
                          }}
                        >
                          {t("show more")}
                        </div>
                      </div>
                    </div>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </div>
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger asChild>
                {item?.milestoneIndicator ? (
                  <div
                    className={`h-3.5 w-3.5 rounded-sm rotate-45  ${item?.flag == "Green"
                      ? "bg-flag-green"
                      : item?.flag == "Red"
                        ? "bg-flag-red"
                        : item?.flag == "Orange"
                          ? "bg-flag-orange"
                          : ""
                      }`}
                  ></div>
                ) : item?.flag == "Green" ? (
                  <img src={GreenFlag} className="h-4 w-4" />
                ) : item?.flag == "Red" ? (
                  <img src={RedFlag} className="h-4 w-4" />
                ) : item?.flag == "Orange" ? (
                  <img src={OrangeFlag} className="h-4 w-4" />
                ) : (
                  ""
                )}
              </TooltipTrigger>
              <TooltipContent>
                {item?.flag == "Green"
                  ? t("ON_TIME")
                  : item?.flag == "Red"
                    ? t("SIGNIFICANT_DELAY")
                    : item?.flag == "Orange"
                      ? t("MODERATE_DELAY")
                      : ""}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      },
    },
    {
      key: "taskName",
      header: t("task_name"),
      sorting: true,
      width: 250,
      onCellRender: (item: Task) => (
        <div
          className={`flex gap-2 items-center  cursor-pointer underline text-primary-500 w-full truncate`}
          onClick={() => tryOpenTaskModal(item.taskId)}
        >
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger asChild>
                <div
                  className={`truncate w-32 ${item.parentTaskId ? "italic" : ""
                    }`}
                >
                  {item.taskName}
                </div>
              </TooltipTrigger>
              <TooltipContent>{item.taskName}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      ),
    },
    {
      key: "status",
      header: t("status"),
      sorting: true,
      width: 130,
      onCellRender: (item: Task) => (
        <div
          className={`w-32 h-8 px-3 py-1.5 ${getStatusColor(
            item.status
          )} rounded justify-center items-center gap-px inline-flex`}
        >
          <div className="text-xs font-medium leading-tight">
            {t(item.status)}
          </div>
        </div>
      ),
    },
    {
      key: "startDate",
      header: t("start_date"),
      sorting: true,
      width: 110,
      onCellRender: (item: Task) => (
        <>{dateFormater(new Date(item.startDate))}</>
      ),
    },
    {
      key: "endDate",
      header: t("end_date"),
      sorting: true,
      width: 110,
      onCellRender: (item: Task) => (
        <>{dateFormater(new Date(item.dueDate ?? item.endDate))}</>
      ),
    },
    {
      key: "duration",
      header: t("Duration"),
      sorting: true,
      width: 90,
      onCellRender: (item: Task) => <>{item.duration ?? 0}</>,
    },
    {
      key: "assigned",
      header: t("assigned_to"),
      width: 130,
      onCellRender: (item: Task) => (
        <div className="w-full my-3 flex justify-center items-center">
          <div className="max-w-24 grid grid-cols-[repeat(auto-fit,minmax(10px,max-content))] mr-2">
            {item.assignedUsers.slice(0, 3).map((item, index) => {
              const zIndex = Math.abs(index - 2);
              return (
                <>
                  <div key={index} style={{ zIndex: zIndex }}>
                    <UserAvatar
                      className={`shadow-sm h-7 w-7`}
                      user={item.user}
                    ></UserAvatar>
                  </div>
                </>
              );
            })}
            {item.assignedUsers && item.assignedUsers?.length > 3 && (
              <div className="bg-gray-200/30 w-8  text-lg font-medium h-8 rounded-full flex justify-center items-center">
                {`${item.assignedUsers.length - 3}+`}
              </div>
            )}
            {item.assignedUsers.length <= 0 ? "N/A" : ""}
          </div>
        </div>
      ),
    },
    {
      key: "completionPecentage",
      header: t("Actual Progress"),
      sorting: true,
      width: 150,
      onCellRender: (item: Task) => (
        <PercentageCircle
          percentage={item.completionPecentage ?? 0}
          roundColor={`${item.flag == "Green"
            ? "#34D399"
            : item.flag == "Red"
              ? "#FB7185"
              : item.flag == "Orange"
                ? "#FBBF24"
                : ""
            } `}
        />
      ),
    },
    {
      key: "Expected progress",
      header: t("Expected progress"),
      sorting: true,
      width: 150,
      onCellRender: (item: Task) => (
        <PercentageCircle
          percentage={Math.min(item?.plannedProgression ?? 0, 100)}
          roundColor={`${item.flag == "Green"
            ? "#34D399"
            : item.flag == "Red"
              ? "#FB7185"
              : item.flag == "Orange"
                ? "#FBBF24"
                : ""
            } `}
        />
      ),
    },
    ...(isCollaborator()
      ? [
        {
          key: "Action",
          header: t("actions"),
          width: 70,
          onCellRender: (item: Task) => (
            <>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <div className="cursor-pointer px-3 py-1.5 bg-transparent justify-center items-center gap-px inline-flex">
                    <img src={NewEditIcon} className="mr-2 h-4 w-4" />
                  </div>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-fit flex flex-col gap-1 bg-white shadow rounded">
                  <DropdownMenuItem onClick={() => tryDuplicateTask(item.taskId)}>
                    <img
                      src={DuplicateIcon}
                      className="mr-2 h-4 w-4 "
                      alt=""
                    />
                    <span className="p-0 font-normal h-auto">
                      {t("duplicate_task")}
                    </span>
                  </DropdownMenuItem>
                  <DropdownMenuSeparator className="mx-1" />
                  <DropdownMenuItem onClick={() => tryOpenTaskModal(item.taskId)}>
                    <img src={Edit} className="mr-2 h-4 w-4 " alt="" />
                    <span className="p-0 font-normal h-auto">
                      {t("view_tasks")}
                    </span>
                  </DropdownMenuItem>
                  <DropdownMenuSeparator className="mx-1" />
                  {allowed(item) && (
                    <DropdownMenuItem
                      onClick={() => setShowConfirmDelete(item.taskId)}
                    >
                      <img
                        src={TrashCan}
                        className="mr-2 h-4 w-4 text-[#44546F]"
                      />
                      <span className="p-0 font-normal h-auto text-red-500">
                        {t("remove")}
                      </span>
                    </DropdownMenuItem>
                  )}
                </DropdownMenuContent>
              </DropdownMenu>
            </>
          ),
        },
      ]
      : []),
  ];
  useEffect(() => {
    if (props.data) {
      setSelectedTasks([]);
      setTaskData(
        setData(props.data)?.sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        )
      );
      setFilterData(
        setData(props.data)?.sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        )
      );
    }
  }, [props.data]);


  const getStatusColor = (status: string) => {
    switch (status) {
      case TaskStatusEnumValue.NOT_STARTED:
        return "!bg-status-gray text-white";
      case TaskStatusEnumValue.IN_PROGRESS:
        return "!bg-status-blue text-white";
      case TaskStatusEnumValue.COMPLETED:
        return "!bg-status-green text-white";
    }
  };
  // useEffect(() => {
  //   allTaskQuery.refetch();
  //   setFilterData([])
  // }, [projectId]);


  const setData = (data: Task[] | undefined) => {
    if (data) {
      data.forEach((task) => {
        task.subtasks =
          props.data.filter(
            (subtask) => subtask.parentTaskId === task.taskId
          ) ?? [];
      });
      const topLevelTasks = data.filter((task) => task.parentTaskId === null);
      if (topLevelTasks.length == 0 && data.length > 0) {
        return data.map((task) => convertTask(task));
      } else {
        return topLevelTasks.map((task) => convertTask(task));
      }
    }
  };

  const convertTask = (originalTask: Task) => {
    const convertedTask: Task & { tasks?: Task[] } = originalTask;
    if (originalTask.subtasks) {
      convertedTask.tasks = originalTask.subtasks.map((subtask) =>
        convertTask(subtask)
      );
    }

    return convertedTask;
  };




  // const createTask = () => {
  //   setTaskId("");
  //   setTaskCreate(true);
  // };
  const removeTaskMutation = useRemoveTaskMutation();
  const removeTask = () => {
    if (showConfirmDelete) {
      removeTaskMutation.mutate(showConfirmDelete, {
        onSuccess(data) {
          setShowConfirmDelete(null);
          allTaskQuery.refetch();
          toast.success(data.data.message);
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      });
    }
  };

  const subTableRender = (task: Task, level = 0) => {
    return (
      <div className={`shadow-[0px_0px_34px_0px_#0000001A]  w-full over `}>
        {task.subtasks.length > 0 && (
          <Table
            data={task.subtasks.sort(
              (a, b) =>
                new Date(a.startDate).getTime() -
                new Date(b.startDate).getTime()
            )}
            columnDef={
              level >= 0
                ? columnDef.map((d) => {
                  return {
                    ...d,
                    className: () => {
                      return ``;
                    },
                  };
                })
                : columnDef ?? []
            }
            onAccordionRender={(task) =>
              task.subtasks.length > 0 ? subTableRender(task, level + 1) : <></>
            }
            className={`border-0 !px-0 !rounded-none [&>*]:!overflow-hidden !bg-zinc-100  `}
            hidePagination={true}
            hideHeaders={true}
            hideScrollbar={false}
            expandAll={props.expandChild}
            showDropDown={(data: Task) => {
              return data.subtasks.length > 0 ? "" : "opacity-0";
            }}
          />
        )}
      </div>
    );
  };

  const allowed = (task: Task | undefined) => {
    const project = listProject;
    const me = user.user;
    if (!me || !project) {
      return false;
    }
    if (
      task &&
      project.assignedUsers.find(
        (u) =>
          u.user.userId == me.userId &&
          u.projectRole == UserRoleEnumValue.TEAM_MEMBER,
      ) &&
      task.createdByUserId == me.userId
    ) {
      return true;
    }
    return canManageProjectTasksAndContent(
      me,
      me.userOrganisation[0]?.role,
      project.assignedUsers,
      normalizeProjectScope(project),
    );
  };

  return (
    <div className="h-full overflow-hidden">
      <div className="w-full flex flex-col  gap-3 h-full">
        <div className="!h-full">
          <Table
            enableColumnCustomization={true}
            hiddenColumnsKey="tasks_table_hidden_columns"
            columnDef={columnDef}
            data={filterData ?? []}
            onAccordionRender={(task) => subTableRender(task)}
            className="!pt-1 !pb-0 !sm:pb-7 !h-[100%] !px-0 "
            hideScrollbar={false}
            expandAll={props.expandChild}
            showDropDown={(data: Task) => {
              return data.subtasks.length > 0 ? "" : "opacity-0";
            }}
            showDropDownArrow={(data: Task) => {
              return data.subtasks.length ? "" : "opacity-0 !cursor-default";
            }}
          />
        </div>
      </div>
      {(Boolean(taskId) || taskCreate) && (
        <TaskSubTaskForm taskId={taskId} projectId={projectId} close={close} />
      )}
      <Dialog
        isOpen={Boolean(showConfirmDelete)}
        onClose={() => { }}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeTaskMutation.isPending}
              disabled={removeTaskMutation.isPending}
              onClick={() => setShowConfirmDelete(null)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              onClick={removeTask}
              isLoading={removeTaskMutation.isPending}
              disabled={removeTaskMutation.isPending}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>

      <ProjectStatusEditBlockedDialog
        isOpen={isProjectEditBlockedDialogOpen}
        onClose={() => setIsProjectEditBlockedDialogOpen(false)}
        projectStatus={projectStatus}
        projectSettingsLink={openProjectSettingsLink}
        modalClass="rounded-lg"
      />
    </div>
  );
}

export default Tasks;
